export default __webpack_public_path__ + "static/media/big-leaf-plant.153953f8.svg";